import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export interface AssessmentContractData {
    evaluationType: number;
    languageId: number;
    settingId: number;
    serviceArea: number;
    interpreterType: number;
    awardedRate: string;
}

export interface AssessmentReferenceData {
    assessUsedDropdown: IReferenceData[];
    languageDropdown: IReferenceData[];
    settingsDropdown: IReferenceData[];
    serviceAreaDropdown: IReferenceData[];
    interpreterTypeDropdown: IReferenceData[];
}

export class ExportAssessmentContract {
    evaluationType: string;
    languageId: string;
    settingId: string;
    serviceArea: string;
    interpreterType: string;
    awardedRate: string;
    ownerContact: string | null;
    ownerEmail: string | null;
    ownerSe: string | null;
    tempContractNumber: string | null;
    isActive: boolean;
    lastModUser: string | null;
    lastModTs: string | null;
  
    constructor(data: AssessmentContractData, referenceData: AssessmentReferenceData) {
      this.evaluationType = this.dropdownData(data?.evaluationType, referenceData?.assessUsedDropdown)?.description;
      this.languageId =this.dropdownData(data?.languageId, referenceData?.languageDropdown)?.description;
      this.settingId =this.dropdownData(data?.settingId, referenceData?.settingsDropdown)?.description;
      this.serviceArea = this.dropdownData(data?.serviceArea, referenceData?.serviceAreaDropdown)?.description;
      this.interpreterType = this.dropdownData(data?.interpreterType, referenceData?.interpreterTypeDropdown)?.description;
      this.awardedRate = data?.awardedRate;
    }
    dropdownData(id: number, dropDownName: IReferenceData[]): IReferenceData | undefined {
        return dropDownName?.find((x: IReferenceData) => x.id === id);
      }
  }
  